import { useRouter } from 'next/router';
import { decodeSearchQuery } from '../queryEncoding';

export const useOriginalSearchQuery = () => {
  const { query } = useRouter();

  return decodeSearchQuery(query) ?? '';
};
